import configData from '../../config.json';
import axios from 'axios';

export const GetResults = async (v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `exam/get`,
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}